import React, { useEffect, useState } from "react";
import { Divider, Grid, Step, StepContent, StepLabel, Stepper,CircularProgress } from "@mui/material";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate ,useParams} from "react-router-dom";
import { toast } from "react-toastify";
import { OnlyDateTimeConverter } from "../../Components/Helpers/DateTimeConverter";
import { ApplicationHistoryData,MedicalData } from "./Data/ConstableData";
import { GreenColorButton, PrimeGrayBorderColorButton, RedColorButton, StatusStyle } from "../../Components/MaterialButtonStyle/StyleButton";
import PSCLogo from "../../Assets/Logo/PSCLogo.jpg";
import TextAreaField from "../../Components/CustomInputs/TextArea";
import ApplicationDetails from "./ApplicationDetails";
import ApplicationDetails1 from "./ApplicationDetails1";
import ApplicationHistoryTable from "./ApplicationHistoryTable";
import ApplicationProcess from "./ApplicationProcess";
import CustomModal from "../../Components/Modal/CustomModal";
import { GetPublicURL, PostMethod } from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader"
const ApplicantsDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [applicationDetail, setApplicationDetail] = useState("");
  const [CandidateDetail, setCandidateDetail] = useState("");
  const [applicationDetailsModal, setApplicationDetailsModal] = useState(false);
  const [RejectStatus, setRejectStatus] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false)
  const [physicalTest, setphysicalTest] = useState([])
  const [PhysicalTest, setPhysicalTest] = useState([])
  const [kindetails, setkindetails] = useState([])
  const [physicalTestLocations, setphysicalTestLocations] = useState([])
  const [MedicalTestLocations, setMedicalTestLocations] = useState([])
  const [ComputerTestLocations, setComputerTestLocations] = useState([])
  const [EducationQualifications, seteducation_qualification] = useState([])
  const [refereeinformation, setrefereeinformation] = useState([])
  const [furtherinformation, setfurtherinformation] = useState([])
  const [PhysicalDataDetails, setPhysicalDataDetails] = useState([])
  const [ApplicationBasicDetails, setApplicationBasicDetails] = useState([])
  const [computerTestlist, setcomputerTestlist] = useState([])
  const [MedicaltestsList, setMedicaltestsList] = useState([])
  const [MedicalDataDetails, setMedicalDataDetails] = useState([])
  const [WorkFlow, setWorkFlow] = useState([])
  const [ApplicantImages, setApplicantImages] = useState()

  const [Applicationtstatus, setApplicationtstatus] = useState("Pending")
  const [computertestStatus, setcomputertestStatus] = useState("Pending")
  const [physicaltestStatus, setphysicaltestStatus] = useState("Pending")
  const [MedicaltestStatus,  setMedicaltestStatus] = useState("Pending")
  const [statusMapping ,setstatusMapping] = useState({
    "Job Application": Applicationtstatus,
    "Physical Test": physicaltestStatus,
    "Computer Based Test": computertestStatus,
    "Medical Screening": MedicaltestStatus,
    "Final Results & Appointment": "",
  });

  const [setp1date, setsetp1date] = useState()
  const [setp2date, setsetp2date] = useState()
  const [setp3date, setsetp3date] = useState()
  const [setp4date, setsetp4date] = useState()
  const [setp5date, setsetp5date] = useState()

  const [RejectReason, setRejectReason] = useState()
  const [RejectLoader, setRejectLoader] = useState(false)
  const adminUUID =localStorage.getItem("@userid") 
  useEffect(() => {
    if(params.id){
      GetApplicationDetails(params.id);
    }
  }, [params])
  const GetApplicationDetails = async(id) => {
    try{
      let url ="test/viewapplications"
      let method="POST"
      let params ={
        job_application_uuid:id
      }
      setShowLoader(true)
      const response = await PostMethod({url,method,params})
      if(response.status){
        let applicationsts =""
        let physicalsts =""
        let cbtsts =""
        let medicalsts =""
        let Final =""
        let CurrentStep =[]
        console.log("Response",response)
        if(response.jobapplication[0]?.status){
          let item = response.jobapplication[0]
          response.jobapplication[0].status= item.job_current_status =="submitted"? "Under Review":item.job_current_status =="accepted"? "Call Letter Received": item.job_current_status=="phy-approved"?"phy-approved":""
        }
        let workflowarray =[]
        if(response.jobapplication[0]){
          let item = response.jobapplication[0]
          if(item){
            item.job_workflow?.map((item)=>{
              if(item.value){
                workflowarray.push(  { label: item.name })
              }
            })
            setWorkFlow(workflowarray)
          }
        }
        const stepIndexMapping = workflowarray?.reduce((acc, step, index) => {
          acc[step.label] = index+1;
          return acc;
        }, {});
       
        setApplicationDetail(response.jobapplication[0])
        if(response.jobapplication[0].applicant_image){
          const Images =await GetPublicURL(response.jobapplication[0].applicant_image)
          setApplicantImages(Images)
        }
        if(response.jobapplication[0]?.applicant_temp_details){
          let data =response.jobapplication[0]?.applicant_temp_details
          const formattedArray = [
            data.reduce((result, item) => {
              const sanitizedKey = item.name.replace(/\s+/g, ""); // Remove spaces from the key
              result[sanitizedKey] = item.value; // Assign the value to the sanitized key
              result["applicant_image"] = response.jobapplication[0].applicant_image
              return result;
            }, {})
          ];
          setCandidateDetail(formattedArray[0])
        }
        if(response?.medicaltest[0]?.medical_test_current_status=="pending"){
          setMedicalDataDetails(MedicalData)
        }else{
          setMedicalDataDetails(response?.medicaltest[0].medical_test_data)
        }
        if(response.physicaltest){
          let array =[]
          let dates =""
          let arrays =[]
          response.physicaltest.map((item)=>{
            if(item.physical_test_current_status!="pending" && item.physical_test_current_status!="rejected"){
              array.push(true)
              dates=item.physical_test_examined_at
            }
            if(response?.jobapplication[0]?.applications_accepted){
              item.status = "call letter received"
              setApplicationtstatus("Accepted")
              applicationsts ="Accepted"
            }
            if(item.physical_test_current_status =="rejected"){
              dates=item.physical_test_examined_at
              arrays.push(item.physical_test_current_status)
            }
          })
          if(response?.jobapplication[0]?.physical_test){
            setPhysicalTest(response.jobapplication[0].physical_test)
          }

          if(arrays.length>0){
            setphysicaltestStatus("Rejected")
            setApplicationtstatus("Rejected")
            applicationsts ="Rejected"
            physicalsts="Rejected"
            CurrentStep.push(stepIndexMapping["Job Application"])
            setsetp2date(dates)
          }
          if(array.length==1){
            setphysicalTest(response.physicaltest)
           
            physicalsts ="Pending"
          }
          if(array.length==2){
            setphysicalTest(response.physicaltest)
            setPhysicalDataDetails(response.physicaltest[0].physical_test_data)
            setphysicaltestStatus("Passed")
            setApplicationtstatus("Accepted")
            applicationsts ="Accepted"
            physicalsts="Passed"
          
            CurrentStep.push(stepIndexMapping["Physical Test"])
            setsetp2date(dates)
          }
        }
        setphysicalTestLocations(response.jobapplication[0].physical_locations)
        setMedicalTestLocations(response.jobapplication[0].medical_locations)
        setComputerTestLocations(response.jobapplication[0].computer_locations)
        setkindetails(response.jobapplication[0].kin_details)
        seteducation_qualification(response.jobapplication[0].education_qualification)
        setrefereeinformation(response.jobapplication[0].referee_information)
        setfurtherinformation(response.jobapplication[0].further_information)

        if(response?.jobapplication[0]?.rejected_status){
          setsetp2date(response?.jobapplication[0].job_updated_on)
          setsetp1date(response?.jobapplication[0].job_created_at)
          if(response?.jobapplication[0].applications_accepted){
            setApplicationtstatus("Accepted")
            applicationsts ="Accepted"
            CurrentStep.push(stepIndexMapping["Physical Test"])
            setsetp1date(response?.jobapplication[0].job_updated_on)
          }
          if(response?.jobapplication[0].cbt_accepted){
            setsetp3date(response.computertest[0].computer_test_updated_on)
            setphysicaltestStatus("Passed")
            physicalsts="Passed"
            setcomputertestStatus("Pending")
            cbtsts="Pending"
            CurrentStep.push(stepIndexMapping["Computer Based Test"])
          }
          if(response?.jobapplication[0].medical_accepted){
            setsetp4date(response?.medicaltest[0].medical_test_updated_on)
            setMedicaltestStatus("Passed")
            medicalsts="Passed"
            CurrentStep.push(stepIndexMapping["Medical Screening"])
          }else{
            CurrentStep.push(0)
          }
          setsetp5date(response.jobapplication[0].job_updated_on)
          if(!response?.jobapplication[0].applications_accepted){
            if(response?.jobapplication[0]?.job_current_status=="rejected"){
              setApplicationtstatus("rejected")
              applicationsts ="rejected"
              setsetp1date(response.jobapplication[0].job_updated_on)
            }
          }
         
          let largestNumber = Math.max(...CurrentStep);
          setActiveStep(largestNumber)
          setstatusMapping({
            "Job Application": applicationsts,
            "Physical Test": physicalsts,
            "Computer Based Test": cbtsts,
            "Medical Screening": medicalsts,
            "Final Results & Appointment": Final,
          })
          setShowLoader(false)
          return
        }
        if(response?.jobapplication[0]?.applications_accepted){
          setApplicationtstatus("Accepted")
          applicationsts ="Accepted"
        }
        if(response?.computertest && response?.jobapplication[0].phy_accepted){
          setphysicalTest(response.physicaltest)
          physicalsts ="Pending"
        }
        if(response?.computertest && response?.jobapplication[0].cbt_accepted){
          if(response?.computertest[0].computer_test_current_status=="failed"){
            setcomputertestStatus("failed")
            cbtsts="failed"
          }else{
            setApplicationBasicDetails(response.computertest[0])
            cbtsts="Pending"
          }
          setcomputerTestlist(response?.computertest)
        }
     
        if(response?.computertest[0]?.job_current_status=="cbt_completed"){
          CurrentStep.push(stepIndexMapping["Computer Based Test"])
          cbtsts="Passed"
         
        }
        if(response?.computertest[0]?.computer_test_current_status=="completed"){
          if(response?.computertest[0].pass_status){
            CurrentStep.push(stepIndexMapping["Computer Based Test"])
            cbtsts="Passed"
          }else if(response?.computertest[0].fail_status){
            CurrentStep.push(stepIndexMapping["Computer Based Test"])
            cbtsts="rejected"
          }else{
            CurrentStep.push(stepIndexMapping["Computer Based Test"])
            cbtsts="submitted"
          }
          setApplicationBasicDetails(response.computertest[0])
          setsetp3date(response.computertest[0].computer_test_updated_on)
        }
        if(response?.medicaltest[0]&& response?.jobapplication[0]?.medical_accepted){
          medicalsts="Pending"
          setMedicaltestsList(response?.medicaltest)
        }
        if(response?.medicaltest[0]?.medical_test_current_status=="approved"){
          CurrentStep.push(stepIndexMapping["Medical Screening"])
          setsetp4date(response?.medicaltest[0].medical_test_updated_on)
          setMedicaltestStatus("Passed")
          medicalsts="Passed"

        }
        if(response?.medicaltest[0]?.medical_test_current_status=="rejected"){
          setsetp4date(response?.medicaltest[0]?.medical_test_updated_on)
          setMedicaltestStatus("rejected")
          medicalsts="rejected"
        }
        if(response?.jobapplication[0]){
          setsetp1date(response.jobapplication[0].job_created_at)
        }
        if(response?.jobapplication[0].job_current_status=="Finalised"){
          CurrentStep.push(5)
          Final="Completed"
          setsetp5date(response.jobapplication[0].job_updated_on)
        }
        if(response?.physicaltest[0]?.physical_test_current_status=="pending"){
          
          setPhysicalDataDetails(response.jobapplication[0].physical_test)
        }else{
          setPhysicalDataDetails(response.physicaltest[0].physical_test_data)
        }
        let largestNumber = Math.max(...CurrentStep);
        setActiveStep(largestNumber)
        setstatusMapping({
          "Job Application": applicationsts,
          "Physical Test": physicalsts,
          "Computer Based Test": cbtsts,
          "Medical Screening": medicalsts,
          "Final Results & Appointment": Final,
        })

        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    }catch(Error){
      setShowLoader(false)
      console.log("Error",Error)
    }
  }
  const RejectAppication = async() => {
    if(!RejectReason){
      toast.error("Enter valid Reject Reason")
      return
    }
    if(RejectReason.trim()?.length<10){
      toast.error("Enter valid Reject Reason, minimum 10 characters")
      return
    }
    try{
      let url="application/rejectjobapplications"
      let method = "POST"
      let params ={
        "job_application_id":params.id,
        "rejections_reason":RejectReason,
        "admin_id":adminUUID
      }
      setRejectLoader(true)
      const response = await PostMethod({url,method,params})
      if(response.status){
        setRejectLoader(false)
        toast.success("Application Rejected")
        GetApplicationDetails(params.id);
      }else{
        setRejectLoader(false)
      }
    }catch(Error){
      setRejectLoader(false)
      console.log("Error",Error)
    }
  }
  const dateMapping = {
    "Job Application": setp1date,
    "Physical Test": setp2date,
    "Computer Based Test": setp3date,
    "Medical Screening": setp4date,
    "Final Results & Appointment": setp5date,
  };
  const JobWorkFlow = ()=>{
    return(
      <Stepper activeStep={activeStep} orientation="vertical">
        {
          WorkFlow.map((step, index) => {
            const stepDate = dateMapping[step.label];
            return(
              <Step key={step.label}>
                <StepLabel sx={{
                  "& .MuiStepLabel-label.Mui-active": { color: "#A7ABA9",  },
                  "& .MuiStepLabel-iconContainer .Mui-active": { color: "#A7ABA9",fontFamily: "PoppinsMedium"},
                  "& .MuiStepLabel-label.Mui-completed": { color: "#222222", fontFamily: "PoppinsMedium", },
                  "& .MuiStepLabel-iconContainer .Mui-completed": { color: "#0FBE7C", fontFamily: "PoppinsMedium" },
                }}>
                  <Grid item lg={12} container>
                    <Grid item container flexDirection={"row"}>
                      <p className="poppinsRegular Text-Prime-Black text-left">{step.label}</p>
                      <Grid item className="mx-2">
                        <p className={StatusStyle(statusMapping[step.label])}>{statusMapping[step.label]}</p>
                      </Grid>
                    </Grid>
                    {/* **Dynamic Date Handling** */}
                    <Grid item container>
                      {stepDate && (
                        <p className="poppinsRegular Text-Prime-Black text-left">
                          {OnlyDateTimeConverter(Number(stepDate))}
                        </p>
                      )}
                    </Grid>
                  </Grid>
                </StepLabel>
                <StepContent>

                  {index == WorkFlow.length-1 && activeStep >= WorkFlow.length-1 && localStorage.getItem("@userType")!="applicant"  &&
                    <Grid item container>
                      <GreenColorButton className="px-4 py-2">Confirm Final Appointment</GreenColorButton>
                    </Grid>}
                </StepContent>
              </Step>
            )
          })
        }
      </Stepper>
    )
    
  } 
  return (
    <Grid container item lg={12} sm={12} md={12} xs={12} >
      <Grid container item lg={12} sm={12} md={12} xs={12} alignItems={"center"} >
        <button
          className="btn btn-0 border-0 ButtonFoucusNone"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft color="#222222" size={"20px"} />
        </button>
        <h4 className="poppinsMedium Text-Prime-Black text-center">
          View Applicant Details
        </h4>
      </Grid>
      <Grid container item lg={12} sm={12} md={12} xs={12} justifyContent={"space-between"} borderRadius={"6px"} className="py-3">
        <Grid item lg={4} sm={4} md={4} xs={4}  >
          <Grid container item lg={12} sm={12} md={12} xs={12} bgcolor={"#FFFFFF"} borderRadius={"6px"} flexDirection={"column"} alignItems={"flex-start"} className="p-3">
            <h4 className="poppinsSemiBold Text-Prime-Black text-center">
              Overview
            </h4>
            <Divider className="mt-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />

            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2 borderBottom" justifyContent={"space-between"}>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsMedium Text-Prime-Black text-left">
                  NIN Number
                </p>
              </Grid>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsRegular Text-Prime-Black text-left">
                  *******6554
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2 borderBottom" justifyContent={"space-between"}>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsMedium Text-Prime-Black text-left">
                  Main Phone
                </p>
              </Grid>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsRegular Text-Prime-Black text-left">
                  {CandidateDetail?.MainPhoneNumber ? "+234"+(CandidateDetail.MainPhoneNumber) : "--"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2 borderBottom" justifyContent={"space-between"}>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsMedium Text-Prime-Black text-left">
                  Contact Email
                </p>
              </Grid>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsRegular Text-Prime-Black text-left">
                  {CandidateDetail?.Email ? (CandidateDetail.Email) : "--"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2 borderBottom" justifyContent={"space-between"}>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsMedium Text-Prime-Black text-left">
                  State
                </p>
              </Grid>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsRegular Text-Prime-Black text-left">
                  {CandidateDetail.StateofOrigin}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2 borderBottom" justifyContent={"space-between"}>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsMedium Text-Prime-Black text-left">
                  Applied on
                </p>
              </Grid>
              <Grid item lg={6} sm={6} md={6} xs={6}>
                <p className="poppinsRegular Text-Prime-Black text-left">
                  {applicationDetail?.job_created_at ? OnlyDateTimeConverter(applicationDetail.job_created_at) : "--"}
                </p>
              </Grid>
            </Grid>
            {(localStorage.getItem("@userType") == "fieldagentsupervisor"||localStorage.getItem("@userType") == "applicant") &&
              <Grid item lg={12} sm={12} md={12} xs={12} container justifyContent={"center"} className="pt-2">
                <GreenColorButton
                  type="submit"
                  className="px-3 py-2 ml-3"
                  onClick={() => setApplicationDetailsModal(true)}
                >
                  View Application
                </GreenColorButton>
              </Grid>
            }

          </Grid>
          {(localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" || localStorage.getItem("@userType") == "applicant") &&
            <Grid container item lg={12} sm={12} md={12} xs={12} bgcolor={"#FFFFFF"} borderRadius={"6px"} flexDirection={"column"} alignItems={"flex-start"} className="my-3 p-3">
              <h4 className="poppinsSemiBold Text-Prime-Black text-center">
                Recruitment Workflow
              </h4>
              <Divider className="mt-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2">
                <JobWorkFlow />
              </Grid>
            </Grid>
          }
          {(localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin") &&
            <ApplicationHistoryTable ApplicationHistoryData={ApplicationHistoryData} />
          }
        </Grid>
        <Grid item lg={7.8} sm={7.8} md={7.8} xs={7.8} >
          <Grid container item lg={12} sm={12} md={12} xs={12} bgcolor={"#FFFFFF"} borderRadius={"6px"} flexDirection={"column"} alignItems={"flex-start"} className="p-3">
            <h4 className="poppinsSemiBold Text-Prime-Black text-center">
              Application Process
            </h4>
            <Divider className="mt-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <ApplicationProcess Loaders={ShowLoader} MedicalDataDetails={MedicalDataDetails} MedicaltestsList={MedicaltestsList} computerTestlist={computerTestlist} CandidateDetail={CandidateDetail} activeStep={activeStep} PhysicalDataDetails={PhysicalDataDetails} setActiveStep={setActiveStep} physicalTest={physicalTest}  ApplicationBasicDetails={ApplicationBasicDetails} GetApplicationDetails={GetApplicationDetails} applicationDetail={applicationDetail} />
          </Grid>
          {localStorage.getItem("@userType") !== "applicant" &&
            <Grid container item lg={12} sm={12} md={12} xs={12} bgcolor={"#FFFFFF"} borderRadius={"6px"} flexDirection={"column"} alignItems={"flex-start"} className="p-3 my-3">
              <h4 className="poppinsSemiBold Text-Prime-Black text-center">
                Application Details
              </h4>
              <Divider className="mt-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} container className="px-2 py-4" alignItems={"center"}>
                <img src={PSCLogo} alt="PSCLogo" height={60} width={60} className="img_fluid" />
                <h3 className="mx-2 poppinsSemiBold Text-Prime-Black text-center">
                  {applicationDetail.job_name}
                </h3>
              </Grid>
              <Divider className="w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"center"} justifyContent={"space-between"}>
                <Grid item lg={10} sm={10} md={10} xs={10} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Name of the Post Applying for
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {applicationDetail?.job_name ? applicationDetail?.job_name : "--"}
                        {/* {applicationDetail?.job_post ? applicationDetail?.job_post : "--"} */}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Notification Number
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {applicationDetail?.job_post_number ? applicationDetail?.job_post_number : "--"}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Application Number
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={2} sm={2} md={2} xs={2} container justifyContent={"flex-end"}>
                  <img src={ApplicantImages} alt="PSCLogo" height={"150px"} width={"150px"} className="img_fluid" />
                </Grid>
              </Grid>
            </Grid>}
          <ApplicationDetails PhysicalList={PhysicalTest} isAffirmation ={true} CandidateDetail={CandidateDetail}  furtherinformation={furtherinformation} EducationQualifications={EducationQualifications} 
            refereeinformation={refereeinformation} kindetails={kindetails} physicalTestLocations={physicalTestLocations} MedicalTestLocations={MedicalTestLocations} ComputerTestLocations={ComputerTestLocations}/>

          {(localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin") &&
            <Grid container item lg={12} sm={12} md={12} xs={12} bgcolor={"#FFFFFF"} borderRadius={"6px"} flexDirection={"row"} justifyContent={"flex-end"} alignItems={"flex-end"} className="p-3 mt-3">
              <PrimeGrayBorderColorButton
                type="submit"
                className="px-5 py-2"
              >
                Close
              </PrimeGrayBorderColorButton>
              {activeStep < 5 &&
                <RedColorButton
                  type="submit"
                  className="px-3 py-2 ml-3"
                  onClick={() => setRejectStatus(true)}
                >
                  Reject Applicant
                </RedColorButton>}
              {activeStep == 5 &&
                <GreenColorButton
                  type="submit"
                  className="px-3 py-2 ml-3"
                  onClick={() => toast.success("Pdf Saved Successfully")}
                >
                  Save as PDF
                </GreenColorButton>}

            </Grid>}

        </Grid>
      </Grid >
      <CustomModal
        open={applicationDetailsModal}
        setOpen={setApplicationDetailsModal}
        divider={false}
        header={true}
        width={"70%"}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            View Application
          </h5>
        }
        modalContent={
          <Grid item lg={12} sm={12} md={12} xs={12} container className="" flexDirection={"column"}>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="px-2 py-2" alignItems={"center"}>
              <img src={PSCLogo} alt="PSCLogo" height={60} width={60} className="img_fluid" />
              <h3 className="mx-2 poppinsSemiBold Text-Prime-Black text-center">
                {applicationDetail?.job_name}
              </h3>
            </Grid>
            <Divider className="w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"center"} justifyContent={"space-between"}>
              <Grid item lg={9} sm={9} md={9} xs={9} container className="p-2" alignItems={"center"}>
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name of the Post Applying for
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_name ? applicationDetail?.job_name : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Notification Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_post_number ? applicationDetail?.job_post_number : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Application Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={3} sm={3} md={3} xs={3} container justifyContent={"flex-end"}>
                <img src={ApplicantImages} alt="profile" height={"200px"} width={"200px"} className="img_fluid" />
              </Grid>
            </Grid>
            <ApplicationDetails1 PhysicalList={PhysicalTest} isAffirmation ={true}  isShowAll={true} furtherinformation={furtherinformation} EducationQualifications={EducationQualifications} 
              refereeinformation={refereeinformation} CandidateDetail={CandidateDetail} kindetails={kindetails} physicalTestLocations={physicalTestLocations} 
              MedicalTestLocations={MedicalTestLocations} ComputerTestLocations={ComputerTestLocations} />
          </Grid>

        }
      />
      <CustomModal
        open={RejectStatus}
        setOpen={setRejectStatus}
        divider={false}
        header={true}
        width={"50%"}
        height={"50%"}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            Reject Applications
          </h5>
        }
        modalContent={
          <Grid item lg={12} sm={12} md={12} xs={12} container className="" flexDirection={"column"}>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="px-2 py-2" alignItems={"center"}>
              <h3 className="mx-2 poppinsSemiBold Text-Prime-Black text-center">
                Are you sure you want to reject this application?
              </h3>
            </Grid>
            <Divider className="w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"center"} justifyContent={"space-between"}>
              <Grid item className="py-2" container>
                <TextAreaField  placeholder="Enter the Reject reason"  fontSize={14}  backgroundColor="#FFFFFF" width={"100%"} maxLength={1000}  padding={"2.5% 3% 2.5% 0%"}
                  placeholderColor="#666666"  border={"1px solid  #666666"}  fontFamily={"PoppinsMedium"}  value={RejectReason}  onChange={(e) => setRejectReason(e.target.value)}
                />
              </Grid>
              <RedColorButton type="submit"  className="px-3 py-2 ml-3" onClick={() => RejectAppication()} >
                {!RejectLoader && "Reject Applicant"}
                {RejectLoader &&<CircularProgress size="1rem" style={{ color: "#fff" }} />}
              </RedColorButton>
            </Grid>
          </Grid>

        }
      />
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
    </Grid >

  );
};

export default ApplicantsDetails;
